import { PatientBackSkip } from '@/components/Atoms'
import { INode } from '@/components/survey/SurveyModel/types/nodeTypes'
import { RootState } from '@/reducers/store'
import {
    useApplyFieldsForNewNodes,
    useValidate,
} from '@/state/survey/formSlice'
import {
    useSetCurrentPage,
    useSetPrevPage,
} from '@/state/survey/patientSuerveySlice'
import formData from '@/utils/Validate/formData'
import { FC, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// Define the props interface for your component
interface MyComponentProps {
    question: INode
    nodes: INode
    getFirstPage: (Nodes: INode) => any
    getLastPage: (Nodes: INode) => any
    setComplete: (val: boolean) => void
}

const BackSkip: FC<MyComponentProps> = (props: MyComponentProps) => {
    //prevPages
    const { setComplete } = props
    const { prevPages, questionnaireDetails, answersObj } = useSelector(
        (state: RootState) => state.patientSurvey
    )
    const [firstPage] = useState(props.getFirstPage(props.nodes))
    const [lastPage] = useState(props.getLastPage(props.nodes))
    const validateInputField = useValidate()

    const updateCurrentPage = useSetCurrentPage()
    const updatePrevPage = useSetPrevPage()
    const isFirstRun = useRef(true)
    const navigate = useNavigate()

    const applyNewFieldValues = useApplyFieldsForNewNodes()

    useEffect(() => {
        if (isFirstRun.current && questionnaireDetails && answersObj) {
            applyNewFieldValues(questionnaireDetails, answersObj.answers) // update form object with actual values
            isFirstRun.current = false
        }
    }, [questionnaireDetails, answersObj])

    const handleClick = (param: string) => {
        if (param === 'back') {
            setComplete(false)
            if (props.question.name === firstPage) {
                navigate('/')
            } else {
                const existingIndex = prevPages?.find(
                    (historyItem) => historyItem.page === props.question.name
                )
                if (existingIndex && existingIndex !== undefined) {
                    updateCurrentPage(existingIndex.prevPage)
                }
                const originalValue = formData.getUnChangedDataaByFieldName(
                    props.question?.name
                )
                validateInputField(props.question?.name, originalValue, true) //Update the question values with the original values. This is a back node, so any temporary changes should be reverted.
            }
        }
        if (param === 'skip') {
            const originalValue = formData.getUnChangedDataaByFieldName(
                props.question?.name
            )

            validateInputField(props.question?.name, originalValue, true) //Update the question values with the original values. This is a skip node, so any temporary changes should be reverted.

            if (props.question?.name === lastPage) {
                setComplete(true)
            } else {
                isFirstRun.current = true
                if (props.question?.skipNode)
                    updatePrevPage(
                        props.question?.skipNode,
                        props.question?.name
                    )
                updateCurrentPage(
                    props.question?.skipNode
                        ? props.question?.skipNode
                        : props.question.name
                )
            }
        }
    }

    return (
        <div className="grid grid-cols-1 back-skip">
            <div className="flex justify-between">
                <PatientBackSkip
                    handleClick={handleClick}
                    isFirstPage={props.question.name === firstPage}
                    direction="left"
                />
                {props.question.name !== 'Complete' ? (
                    <PatientBackSkip
                        handleClick={handleClick}
                        direction="right"
                    />
                ) : (
                    ''
                )}
            </div>
        </div>
    )
}

export default BackSkip
